module.exports = __webpack_public_path__ + "3ba60761d8c802ab83e5ba4a275370ce.mp4";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/temporal-weave.mp4
// module id = 653
// module chunks = 0